import {
  Component,
  EventEmitter,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { FormArray, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatTable } from "@angular/material/table";
import { Subscription } from "rxjs";
import { BaseField } from "../../../../../../../shared/product/baseField";
import { CustomValidators } from "../../../../../../../shared/custom-validators";
import { SlotsService } from "./slots.service";
import { IintialSlot } from "../../calendarSlots.interface";
import moment from "moment";
import { scheduleRepeatFormOutput } from "./schedule-repeat-form/schedule-repeat-form.component";
import { CustomToastService } from "src/app/shared/services/custom-toast.service";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: 'app-calendar-slot',
  templateUrl: './calendar-slot.component.html',
  styleUrls: ['./calendar-slot.component.scss'],
})
export class CalendarSlotComponent extends BaseField implements OnInit {
  @ViewChild(MatTable) table!: MatTable<any>;
   displayDateDayFormat='DD-MM-YYYY';
  repeatScheduleSelected=false;
  selectedDays: string[] = [];
  @Output() hasNoSlot = new EventEmitter();
  daysArray: IintialSlot[] = [];
  noSlot: boolean = true;
  selectedDay;
  subscription!: Subscription;
  slotsForm: FormGroup;
  today: Date = new Date()
  minDate: Date = new Date(
    this.today.getFullYear(),
    this.today.getMonth() ,
    this.today.getDate() + 1
  );
  maxDate: Date = new Date(
    this.today.getFullYear(),
    this.today.getMonth() + 1,
    this.today.getDate()
  );
  bookingTimes = [
    { name: "00:00" },
    { name: "00:30" },
    { name: "01:00" },
    { name: "01:30" },
    { name: "02:00" },
    { name: "02:30" },
    { name: "03:00" },
    { name: "03:30" },
    { name: "04:00" },
    { name: "04:30" },
    { name: "05:00" },
    { name: "05:30" },
    { name: "06:00" },
    { name: "06:30" },
    { name: "07:00" },
    { name: "07:30" },
    { name: "08:00" },
    { name: "08:30" },
    { name: "09:00" },
    { name: "09:30" },
    { name: "10:00" },
    { name: "10:30" },
    { name: "11:00" },
    { name: "11:30" },
    { name: "12:00" },
    { name: "12:30" },
    { name: "13:00" },
    { name: "13:30" },
    { name: "14:00" },
    { name: "14:30" },
    { name: "15:00" },
    { name: "15:30" },
    { name: "16:00" },
    { name: "16:30" },
    { name: "17:00" },
    { name: "17:30" },
    { name: "18:00" },
    { name: "18:30" },
    { name: "19:00" },
    { name: "19:30" },
    { name: "20:00" },
    { name: "20:30" },
    { name: "21:00" },
    { name: "21:30" },
    { name: "22:00" },
    { name: "22:30" },
    { name: "23:00" },
    { name: "23:30" },
  ];

  slotFields = {
    id: {
      fieldName: "id",
      fieldType: "id",
    },
  };
  repeatScheduleForm:FormGroup;
  invalidDay: string = "";

  constructor(private slots: SlotsService, private formBuilder: FormBuilder,private customToast:CustomToastService,private translat:TranslateService) {
    super();
  }

  async ngOnInit() {
    this.slots.daysUpdated.subscribe((selectedDay) => {
      this.repeatScheduleSelected=false;
      const index = this.selectedDays.findIndex(e => e == selectedDay);
      if (index < 0) {
        this.selectedDays.push(selectedDay)
        this.addDay(selectedDay)
        this.addDaySlots(this.selectedDays.length - 1)
      } else {
        this.selectedDays.splice(index, 1)
        this.removeDay(index)
      };
    });
    this.slotsForm = this.formBuilder.group({
      days: this.formBuilder.array([]),
    });
    (this.slotsForm.get("days") as FormArray).valueChanges.subscribe((days: any) => {
      let counter = 0;
      let invalidFormArray = false;
      for (const day of days) {
        let today = moment(day.day, 'DD-MM-YYYY');
        if (moment().diff(today, 'day') > 0) {
          invalidFormArray = true;
          this.invalidDay = day.day;
          break;
        }
        let formGroup = this.getDays().controls[counter];
          this.daysArray = JSON.parse(JSON.stringify(days));
          if (this.daysArray[counter]["slots"].length && formGroup.valid) {
            this.noSlot = false;
            this.hasNoSlot.emit(false);
            this.formControlRef.setValue(this.daysArray);
          } else {
            this.noSlot = true;
            this.hasNoSlot.emit(true);
            this.formControlRef.setValue(null);
            break;
          }
        counter++;
      }
      if (invalidFormArray) {
        this.formControlRef.setValue(null);
      }
    });
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  getDays(): FormArray {
    return this.slotsForm.get("days") as FormArray
  }

  newDay(day): FormGroup {
    return this.formBuilder.group({
      day: day,
      slots: this.formBuilder.array([])
    })
  }

  addDay(day){
    this.getDays().push(this.newDay(day))
  }

  removeDay(index: number){
    this.getDays().removeAt(index)
  }

  getDaySlots(dayIndex: number): FormArray{
    return this.getDays().at(dayIndex).get("slots") as FormArray
  }

  getDaySlot(dayIndex: number, slotIndex: number): FormGroup{
    return (this.getDays().at(dayIndex).get('slots') as FormArray).at(
      slotIndex
    ) as FormGroup;
  }

  newSlot(startAt='',endAt=''): FormGroup{
    return this.formBuilder.group({
      id: '',
      startAt: [startAt, Validators.required],
      endAt: [endAt, [Validators.required, CustomValidators.timeMoreThenStart]]
    })
  }

    addDaySlots(dayIndex: number){
    this.getDaySlots(dayIndex).push(this.newSlot())
  }

  removeDaySlot(dayIndex: number, slotIndex: number){
    if(this.getDaySlots(dayIndex).length === 1) {
        this.noSlot = true;
        this.hasNoSlot.emit(true);
        this.selectedDays.splice(dayIndex, 1);
        this.removeDay(dayIndex);
        return;
    }
    this.getDaySlots(dayIndex).removeAt(slotIndex)
  }
  @Output() reflectScheduleValuesToCalender:EventEmitter<string[]>=new EventEmitter();
  onRepeatSchedule(event: scheduleRepeatFormOutput) {
    this.removeSelectedDaysExceptFirstElement();
    const pickedDaySchedlue:
      { id: string, startAt: string, endAt: string }[] = this.getDaySlots(0).value;
    const repetionDays: string[] = event.repeatDays;
    const endDate = moment(event.endDate);
    const startDate = moment(this.getDays().value[0].day, this.displayDateDayFormat);
    const diffDays = endDate.diff(startDate, 'day');
    this.repeatScheduleSelected = true;
    const origLength=this.selectedDays.length;
    for (let i = 1; i < diffDays; i++) {
      const nextDate = moment(startDate.add(1, 'day'));
      const dayDate = nextDate.format('dddd');
      const isDateSelectedByUser = repetionDays.findIndex(day => day == dayDate) != -1;
      if (isDateSelectedByUser) {
        const displayDate = nextDate.format(this.displayDateDayFormat);
        let index = this.selectedDays.findIndex(x => x == displayDate);
        if (index < 0) {
          this.selectedDays.push(displayDate);
          this.addDay(displayDate);
          index = this.selectedDays.length - 1;
        } else {
          this.getDaySlots(index).clear();

        }
        for (const schedlue of pickedDaySchedlue) {
          this.getDaySlots(index).push(this.newSlot(schedlue.startAt, schedlue.endAt));
        }

      }
    }
    const areDaysModified=this.selectedDays.length!=origLength;
    this.reflectScheduleValuesToCalender.emit(this.selectedDays);

    if(!areDaysModified){
      this.translat.get('Home.CalendarSlots.ScheduleFailed').subscribe(title=>
        this.customToast.addFailedToast(title)
        );
    }else{
      this.translat.get('Home.CalendarSlots.ScheduleAdded').subscribe(title=>
      this.customToast.addSucessToast(title)
      );
    };
  }
  removeSelectedDaysExceptFirstElement() {
    while (this.getDays().length > 1) {
      this.removeDay(1);
    }
    this.selectedDays.splice(1, this.selectedDays.length);
  }
  sortFunction(a, b) {
    return moment(a, this.displayDateDayFormat).diff(moment(b, this.displayDateDayFormat))
  }
  sortBookings() {

    this.selectedDays.sort((a, b) => this.sortFunction(a, b));
    let daysValue: { day: string, slots: any }[] = this.getDays().value;
    let sortedValue = daysValue.sort((a, b) => this.sortFunction(a.day, b.day));
    this.getDays().patchValue(sortedValue);

  }
}
